import Vue from "vue";
import Vuex from "vuex";
import membercontact from "./modules/membercontact";
import userprofile from "./modules/userprofile";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    membercontact,
    userprofile
  }
});
